module.exports = __webpack_public_path__ + "static/img/zhutuSCDC100.e7233ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-4/zhutuSCDC100.png
// module id = Mshy
// module chunks = 0